/**
 * Cart Drawer Items Component
 * This script defines the cart-drawer-items custom element
 * which handles cart item functionality in the drawer
 */

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    console.log('CartDrawerItems initialized');
    
    // Override the sections to render for cart drawer
    this.drawerSections = [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionsToRender() {
    // Use drawer-specific sections if available, otherwise fall back to parent implementation
    return this.drawerSections || super.getSectionsToRender();
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    console.log(`CartDrawerItems: Updating quantity for line ${line} to ${quantity}`);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
          // If cart is now empty, update the drawer content
          if (parsedState.item_count === 0) {
            // Refresh the entire drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            }
          }
        }

        // Update sections
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        // Handle quantity validation messages
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value || 0)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        // Focus handling
        const lineItem = document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`) && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`));
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-drawer-items'});
      }).catch((error) => {
        console.error('Error updating cart:', error);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

// Register the custom element
customElements.define('cart-drawer-items', CartDrawerItems);

// Add diagnostic logging
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (cartDrawerItems) {
    console.log('cart-drawer-items element found on page');
    
    // Find all remove buttons in the cart drawer
    const removeButtons = cartDrawerItems.querySelectorAll('cart-remove-button');
    console.log(`Found ${removeButtons.length} remove buttons in cart drawer`);
    
    // Find all quantity inputs in the cart drawer
    const quantityInputs = cartDrawerItems.querySelectorAll('.quantity__input');
    console.log(`Found ${quantityInputs.length} quantity inputs in cart drawer`);
    
    // Find all plus/minus buttons in the cart drawer
    const plusButtons = cartDrawerItems.querySelectorAll('[name="plus"]');
    const minusButtons = cartDrawerItems.querySelectorAll('[name="minus"]');
    console.log(`Found ${plusButtons.length} plus buttons and ${minusButtons.length} minus buttons in cart drawer`);
  } else {
    console.log('No cart-drawer-items element found on page');
  }
});
